import { CommonModule } from '@angular/common'
import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewEncapsulation,
} from '@angular/core'
import { FormsModule } from '@angular/forms'
import { InputGroupModule } from 'primeng/inputgroup'
import { InputTextModule } from 'primeng/inputtext'
import { DropdownModule } from 'primeng/dropdown'
import { ButtonModule } from 'primeng/button'

@Component({
  selector: 'app-search',
  encapsulation: ViewEncapsulation.None,
  template: `
    <div class="search-container">
      <p-dropdown
        [options]="options"
        [(ngModel)]="selectedOption"
        optionLabel="name"
        placeholder="Material Ids"
        class="material-selector"></p-dropdown>
      <span class="p-input-icon-right" style="width: 41.25rem;">
        @if (searchValue) {
        <p-button
          icon="pi"
          [rounded]="true"
          [text]="true"
          class="clear-btn"
          [raised]="true"
          severity="help"
          (click)="clear()">
          <ng-template pTemplate="iconTemplate">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M19.71 5.72005L18.29 4.30005L12 10.6L5.71004 4.30005L4.29004 5.72005L10.59 12.01L4.29004 18.3L5.71004 19.72L12 13.42L18.29 19.72L19.71 18.3L13.41 12.01L19.71 5.72005Z"
                fill="#5F5F5F" />
            </svg>
          </ng-template>
        </p-button>
        }
        <input
          class="material-input"
          style="width: 400px; padding-left: 1rem"
          type="text"
          pInputText
          (keyup.enter)="search()"
          [placeholder]="placeholder"
          [(ngModel)]="searchValue" />
      </span>
      <p-button
        icon="pi"
        [rounded]="true"
        [text]="true"
        [raised]="true"
        severity="success"
        class="search-btn"
        [disabled]="!searchValue || !selectedOption"
        (click)="search()">
        <ng-template pTemplate="iconTemplate">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M7.99975 14C4.69076 14 1.99976 11.309 1.99976 7.99996C1.99976 4.69096 4.69076 1.99996 7.99975 1.99996C11.3088 1.99996 13.9998 4.69096 13.9998 7.99996C13.9998 11.309 11.3088 14 7.99975 14ZM19.9978 18.584L14.3118 12.897C15.3648 11.543 15.9998 9.84596 15.9998 7.99996C15.9998 3.58896 12.4108 -3.8147e-05 7.99975 -3.8147e-05C3.58876 -3.8147e-05 -0.000244141 3.58896 -0.000244141 7.99996C-0.000244141 12.411 3.58876 16 7.99975 16C9.84575 16 11.5428 15.365 12.8968 14.312L18.5838 19.998L19.9978 18.584Z"
              [attr.fill]="(!searchValue || !selectedOption) ? '#000000' : '#FFFFFF'"  />
          </svg>
          </ng-template>
      </p-button>

      <div style="position: relative;">
        <p-button
          icon="pi"
          [rounded]="true"
          [text]="true"
          [raised]="true"
          severity="success"
          class="multi-btn"
          (click)="toggleMultiPopup()">
          <ng-template pTemplate="iconTemplate">
          <svg 
          width="28" 
          height="28" 
          viewBox="0 0 28 28" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg">
            <path d="M19.2857 15.4286C19.2857 11.065 19.2857 11.9331 19.2857 6.74998C19.2857 5.68486 18.4223 4.82141 17.3572 4.82141H5.78575C4.72063 4.82141 3.85718 5.68486 3.85718 6.74998V24.1071C3.85718 25.1722 4.72063 26.0357 5.78575 26.0357H17.3572C18.4223 26.0357 19.2857 26.1365 19.2857 25.0714" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M7.71436 9.64282H15.4286" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M7.71436 14.4642H15.4286" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M7.71436 19.2856H11.5715" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M8.67871 0.964233H21.2144C21.7259 0.964233 22.2165 1.16742 22.5781 1.5291C22.9398 1.89078 23.143 2.38132 23.143 2.8928V16.3928" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M20.2499 25.0714C22.9127 25.0714 25.0713 22.9128 25.0713 20.25C25.0713 17.5872 22.9127 15.4286 20.2499 15.4286C17.5871 15.4286 15.4285 17.5872 15.4285 20.25C15.4285 22.9128 17.5871 25.0714 20.2499 25.0714Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M27 27L23.6636 23.6636" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </ng-template>
        </p-button>
        @if (showMultiPopup) {
          <div class="multi-popup-panel">
          <div class="panel-arrow"></div>
          <div class="panel-content">
            <div class="panel-title">Bulk Search</div>
              <textarea
                placeholder="Enter multiple Material IDs (one per line)"
                class="bulk-input"
                [(ngModel)]="bulkInputValue"></textarea>

            <div class="panel-actions">
              <button class="btn cancel" (click)="toggleMultiPopup()">Cancel</button>
              <button class="btn confirm" (click)="bulkSearch()">Search</button>
            </div>
          </div>
        </div>

        }
      </div>
    </div>
  `,
  styles: [
    `
      .search-container {
        display: flex;
        border: 1px solid;
        height: 40px;
        border-radius: 0.1875rem;
        border: 1px solid #c0c0c0;
        width: 41.25rem;
        align-items: center;

        .material-selector {
          border-right: 1px solid #c0c0c0;
          & .p-dropdown {
            border: none !important;
            width: 8.75rem;
            box-shadow: none;
            border-radius: 0px;
          }
          & .p-dropdown-label {
            font-family: Siemens Sans;
            font-size: 0.875rem;
            font-style: normal;
            font-weight: 400;
            line-height: 1.2rem; /* 157.143% */
          }
        }
        .p-inputtext {
          border: none;
          box-shadow: none;
        }

        .search-btn {
          background: #8a00e5;
          fill: white;
          height: 2.51rem;

          &.p-disabled {
            background-color: #DEE2E6;
          }
        }

        .multi-btn {
          border-radius: 0 3px 3px 0;
          border: 1px solid #c0c0c0;
          background: #ada9c2;
          height: 2.51rem;
          width: 2.4rem;
          display:inline-block;
          transition: background 0.2s ease;
      }
        .multi-btn:hover {
          background: #958bb3;
          cursor: pointer;
      }
        .clear-btn {
          position: absolute;
          top: 50%;
          margin-top: -1.2em;
          right: -0.45rem;
          padding: 0;
          padding-right: 0.75rem;
        }
        .p-button {
          box-shadow: none;
          padding: 0;
        }
        .material-input {
          color: #969696;
          font-family: Siemens Sans;
          font-size: 14px;
          font-style: normal;
          font-weight: 700;
          line-height: 22px;
          padding: 0;
          &::placeholder {
            color: #969696;
          }
        }

        .p-dropdown-items {
          padding: 0 !important;
        }
      }
    .multi-popup-panel {
      position: absolute;
      top: 110%;
      left: 50%;
      transform: translateX(-50%);
      width: 470px;
      background: #fff;
      border: 1px solid #C0C0C0;
      border-radius: 8px;
      padding: 24px 24px 20px;
      box-shadow: 0 2px 10px rgba(0,0,0,0.15);
      z-index: 100;
      animation: fadeScale .18s ease-out;
    }

    .panel-arrow {
      position: absolute;
      top: -10px;
      left: 50%;
      transform: translateX(-50%);
      width: 20px;
      height: 20px;
      background: white;
      border-left: 1px solid #C0C0C0;
      border-top: 1px solid #C0C0C0;
      transform: translateX(-50%) rotate(45deg);
    }

    .panel-title {
      font-family: Source Serif Pro;
      font-size: 20px;
      font-weight: 700;
      color: #8A00E5;
      margin-bottom: 20px;
    }

    .bulk-input {
      width: 100%;
      height: 200px;
      border: 1px solid #DEE2E6;
      border-radius: 4px;
      resize: none;
      padding: 10px;
      font-family: Source Serif Pro;
      font-size: 14px;
      outline: none;
    }

    .bulk-input::placeholder {
      color: #969696;
      font-size: 12px;
      font-weight: 600;
    }

    .panel-actions {
      display: flex;
      justify-content: flex-end;
      gap: 10px;
      margin-top: 16px;
    }

    .btn {
      width: 80px;
      height: 36px;
      border-radius: 4px;
      border: none;
      font-family: Source Serif Pro;
      font-size: 16px;
      cursor: pointer;
    }

    .btn.cancel {
      background: #DEE2E6;
      color: #111;
    }

    .btn.confirm {
      background: #8A00E5;
      color: white;
    }

    @keyframes fadeScale {
      from {
        opacity: 0;
        transform: translate(-50%, 5px) scale(.95);
      }
      to {
        opacity: 1;
        transform: translate(-50%, 0) scale(1);
      }
}

    `,
  ],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    InputGroupModule,
    InputTextModule,
    DropdownModule,
    ButtonModule,
  ],
})
export class SearchComponent {
  @Input() options: any | undefined
  @Input() searchValue: any | undefined
  @Input() selectedOption: any | undefined
  @Input() placeholder: string | undefined
  @Output() onSearch: EventEmitter<any> = new EventEmitter<any>()

  hasPerformedSearch = false
  showMultiPopup = false
  bulkInputValue: string = ''

  search() {
    if (!this.searchValue || !this.selectedOption) {
      return
    }

    this.hasPerformedSearch = true
    this.onSearch.emit({
      searchValue: this.searchValue,
      selectedOption: this.selectedOption,
    })
  }

  clear() {
    this.searchValue = null
  }

  toggleMultiPopup() {
    this.showMultiPopup = !this.showMultiPopup
    if (!this.showMultiPopup) {
      this.bulkInputValue = ''
    }
  }

  bulkSearch() {
    const ids = this.bulkInputValue
      .split('\n')
      .map(id => id.trim())
      .filter(id => id)
    if (ids.length && this.selectedOption) {
      this.onSearch.emit({
        searchValue: ids,
        selectedOption: this.selectedOption,
        bulk: true,
      })
      this.toggleMultiPopup()
    }
  }
}
